<template>
  <div>
    <div class="sa-mob-cont">
      <button class="sa-btn-back" @click="$parent.caregiver = false">
        <i class="icon-arrow-left"></i>
      </button>
      <h6 class="sa-card-tit sa-ref-tit">Refer to caregiver</h6>
      <div class="sa-h-sm-up">
        <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg3"> -->
        <div class="sa-form-group">
          <input
            type="text"
            class="sa-form-control sa-search-lft"
            id="searchName"
            name="Search Name"
            placeholder="Search"
          />
          <i class="icon-search sa-search-icn"></i>
          <!-- </div> -->
        </div>
      </div>
      <ul class="sa-nurse-list sa-care-list">
        <li v-for="n in 3" :key="n">
          <input type="radio" id="radio" name="radio" value="radio" />
          <label for="radio">
            <figure class="sa-avtar sa-avtar-lg">
              <img
                src="../../../../assets/img/unknown-avtar.png"
                alt="Doctor"
                class="sa-img-cover"
              />
            </figure>
            <span class="sa-nurse-cnt"
              ><strong>Mother and Baby Care</strong
              ><small class="sa-d-block"
                >Hydrocolloid, Hydrogel, Alginate, Collagen</small
              ></span
            >
          </label>
        </li>
      </ul>
    </div>
    <div class="sa-ftr-btn sa-mt50">
      <button class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs">
        Continue
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      radio: "",
      radio1: "",
    };
  },
};
</script>
